import {
  SPEAKER_NOOFSPKR,
  SPEAKER_SPKRLISTVIEW,
  SPEAKER_SPKRPROFVIEW,
  SPEAKER_SPKRSEARCH,
  SPEAKER_SPKRFAVO,
  SPEAKER_ITEM_SELECTED,
  SPEAKER_TOPSPKR_TABLELIST,
  SPEAKER_MOSTSEARKEYS_TABLELIST,
  SPEAKER_ENGAGEMENT_BARCHART,
} from "SpeakeranalyticActions";

export var SpeakerAnalyticMenu = (state = [], action) => {
  //iconName is optional
  var state = [
    {
      key: SPEAKER_NOOFSPKR,
      iconName: "noofspkr",
      sectionName: "Number of speakers",
      sectionDesc: "How many speakers are there in the event",
      selected: false,
    },
    {
      key: SPEAKER_SPKRLISTVIEW,
      iconName: "spkrlistview",
      sectionName: "Speaker's list views",
      sectionDesc: "Number of user who browsed through the speakers list",
      selected: false,
    },
    {
      key: SPEAKER_SPKRPROFVIEW,
      iconName: "spkrprofview",
      sectionName: "Speaker's profile views",
      sectionDesc: "Number of user who browsed through the speakers profiles",
      selected: false,
    },
    {
      key: SPEAKER_SPKRSEARCH,
      iconName: "spkrsearch",
      sectionName: "Speaker searches",
      sectionDesc: "Number of searches done on speaker list",
      selected: false,
    },
    {
      key: SPEAKER_SPKRFAVO,
      iconName: "spkrfavo",
      sectionName: "Speaker favourites",
      sectionDesc: "Number of bookmarked speaker profiles",
      selected: false,
    },
  ];

  var index = 0;
  state[index].selected = true;

  return state;
};

// Initial select tab is "SPEAKER_NOOFSPKR"
export var SpeakerSelectedItem = (state = SPEAKER_NOOFSPKR, action) => {
  if (action.type == SPEAKER_ITEM_SELECTED) {
    state = action.payload.key;
  }

  return state;
};

// Local reducers for Top speakers  list
export var SpeakerTopspkrTablelist = (state = {}, action) => {
  switch (action.type) {
    case SPEAKER_TOPSPKR_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducers for most search keywords related to speakers
export var SpeakerMostsearkeysTablelist = (state = {}, action) => {
  switch (action.type) {
    case SPEAKER_MOSTSEARKEYS_TABLELIST:
      return action.data;
    default:
      return state;
  }
};

// Local reducer for {Speakers Engagement (Chart view of how actively the speaker feature has been use over the selected date range)}

export const SpeakerEngagementbarChart = (state = {}, action) => {
  switch (action.type) {
    case SPEAKER_ENGAGEMENT_BARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
